module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/high-capacity-transport-elite.97ca3eac.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/high-capacity-transport-elite.png
// module id = 3738
// module chunks = 11